export default (cities: string[]) => {
  return cities?.map((value) => {
    return {
      label: value,
      value,
    };
  });
};
